import { Component } from '@angular/core';
import { AppDataRes } from './api/models';
import { AppService } from './api/services';
import { tap } from 'rxjs';
import { app } from './app.config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'BVTPA';

  appData: AppDataRes;

  constructor(
    private appService: AppService,
  ) { }

  ngOnInit(): void {
    this.appService.apiAppDataGet().pipe(
      tap(x => {
        this.appData = x;
        app.data = { ...x };
      })
    ).subscribe();
  }
}
